import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Button, Empty, Space, Select, InputNumber } from "antd";

import { Bar } from "@ant-design/charts";

import moment from "moment";
import { chain, sumBy } from "lodash";
import { ReloadOutlined } from "@ant-design/icons";

import { getLeastWeldInchesList } from "../../features/performance/performanceSlice";

import PickerWithType from "../../libs/components/PickerWithType";
import SelectDateType from "../../libs/components/SelectDateType";
import { GetDateRange } from "../../libs/utils";

function LeastWeldInches(props) {
  const dispatch = useDispatch();
  const least_weld_inches =
    useSelector((state) => state.performance.least_weld_inches) || [];

  const [dateValues, setDateValues] = useState(null);
  const [selectedValues, setSelectedValues] = useState(null);
  const [filterValue, setFilterValue] = useState(100);
  const [type, setType] = useState("range");

  const today = moment();
  const lastWeek = moment().subtract(7, "days");

  useEffect(() => {
    dispatch(
      getLeastWeldInchesList(null, {
        start: lastWeek.format("YYYY-MM-DD"),
        end: today.format("YYYY-MM-DD"),
      })
    );
  }, [dispatch]);

  const data =
    !!least_weld_inches && least_weld_inches.length > 0
      ? chain(least_weld_inches)
          .groupBy("id")
          .map((value, index) => ({
            id: index,
            value: sumBy(value, "value"),
          }))
          .value()
          .sort((a, b) => b.value - a.value)
          .filter((item) =>
            filterValue ? item.value <= filterValue : item.value
          )
      : [];

  return (
    <>
      <Space>
        <b>Least Weld Inches (FDI)</b>

        <SelectDateType value={type} onChange={setType}></SelectDateType>
        <PickerWithType
          type={type}
          defaultValue={[lastWeek, today]}
          onChange={(value) => setDateValues(value)}
        />
        <Button
          disabled={!dateValues}
          onClick={() => {
            const dateRange = GetDateRange(type, dateValues);

            dispatch(
              getLeastWeldInchesList(null, {
                start: dateRange[0],
                end: dateRange[1],
              })
            );
          }}
          icon={<ReloadOutlined />}
        ></Button>

        <InputNumber
          defaultValue={filterValue}
          onChange={(value) => setFilterValue(value)}
          min={0}
        ></InputNumber>

        <Select
          style={{ minWidth: 200 }}
          mode="multiple"
          placeholder="Filter by SWR number"
          options={data
            .map((item) => item.id)
            .filter((v, i, a) => a.indexOf(v) === i)
            .map((item) => ({
              label: `SWR-${item === "1" ? 171 : item}`,
              value: item,
            }))}
          onChange={(values) => {
            setSelectedValues(values);
          }}
        ></Select>
      </Space>

      <div>
        {least_weld_inches &&
        least_weld_inches.length > 0 &&
        data.length > 0 ? (
          <Bar
            {...{
              data:
                !selectedValues || selectedValues.length === 0
                  ? data
                  : data.filter((v, i, a) => {
                      return selectedValues.includes(v.id);
                    }),
              xField: "value",
              yField: "id",
              barWidthRatio: 0.9,
              maxBarWidth: 20,
              label: {
                position: "middle",
                formatter: function (v) {
                  return v.value.toFixed(1);
                },
              },
              xAxis: {
                label: {
                  formatter: function formatter(v) {
                    return v;
                  },
                },
              },
              yAxis: {
                label: {
                  formatter: function formatter(v) {
                    return `SWR-${v === "1" ? 171 : v}`;
                  },
                },
              },
              tooltip: {
                title: (v) => `SWR-${v === "1" ? 171 : v}`,
                formatter: (datum) => {
                  return {
                    name: `SWR-${datum.id === "1" ? 171 : datum.id}`,
                    value: datum.value && datum.value.toFixed(1) + " inches",
                  };
                },
              },
            }}
          />
        ) : (
          <Empty />
        )}
      </div>
    </>
  );
}
export default LeastWeldInches;
